import React from 'react';
import withIcon from '../utilities/withIcon';

const IconKeyboard = () => {
  return (
    <g>
      <path d="m1.05 2 13.901.017c.541 0 .986.41 1.043.936l.006.114v9.883c0 .541-.41.987-.936 1.044L14.95 14H1.05a1.05 1.05 0 0 1-1.044-.936L0 12.95v-9.9c0-.54.41-.986.936-1.043L1.051 2zm.45 1.501V12.5h13V3.516l-13-.015zM11.25 9.5a.75.75 0 1 1 0 1.5h-6.5a.75.75 0 1 1 0-1.5h6.5zM8 7a.75.75 0 1 1 0 1.5A.75.75 0 0 1 8 7zm2.75 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm-5.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm1.5-2a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm-2.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm2.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z" />
    </g>
  );
};

export default withIcon(IconKeyboard);
